import { format } from "date-fns";
import i18n from "./i18n";

enum Lang {
  Ru = "ru",
  En = "en",
}

export function getLanguage(): Lang {
  return i18n.language as Lang.Ru | Lang.En;
}

export async function changeAppLanguage(lang: string) {
  lang = lang.toLowerCase();
  if (["en", "ru"].includes(lang) && i18n.language !== lang) {
    window.localStorage.setItem("appLang", lang);
    await i18n.changeLanguage(lang);
  }
}

export function formatDate(date: string | Date): string {
  const parsedDate =
    date === "string" || date instanceof String ? new Date(date) : date;

  if (parsedDate instanceof Date && isNaN(parsedDate.getTime())) {
    return i18n.t("Invalid Date");
  }

  switch (getLanguage()) {
    case Lang.Ru:
      return format(new Date(date), "dd.MM.yyyy");
    case Lang.En:
      return format(new Date(date), "MM/dd/yyyy");
  }
}

export function formatDateTime(date: string | Date): string {
  const parsedDate =
    date === "string" || date instanceof String ? new Date(date) : date;

  if (parsedDate instanceof Date && isNaN(parsedDate.getTime())) {
    return i18n.t("Invalid Date");
  }

  // Создаем Date объект из UTC строки
  let localDate: Date;

  if (typeof date === "string") {
    // Если строка не содержит 'Z' в конце, добавляем его для явного указания UTC
    const dateString = date.endsWith('Z') ? date : date + 'Z';
    localDate = new Date(dateString);
  } else {
    localDate = new Date(date);
  }

  switch (getLanguage()) {
    case Lang.Ru:
      return format(localDate, "dd.MM.yyyy HH:mm");
    case Lang.En:
      return format(localDate, "MM/dd/yyyy hh:mm a");
  }
}
